import type { AxiosResponseHeaders, RawAxiosResponseHeaders } from "axios";

// Contract: POST /api/recharge-planning-system/api/rest/v1/private/reports
//           GET  /api/recharge-planning-system/api/rest/v1/private/reports/{fileReportId}

export const REPORT_POLICY = "BANK_MANAGEMENT_CYCLIC_INDIVIDUAL_CHARGES";
export const REPORT_PARAMETERS_TYPE = "CYCLIC_CHARGE_REPORT_PARAMETERS";
export const CHARGE_DEFINITION_REPORT_POLICY =
  "SINGLE_CYCLIC_CHARGE_DEFINITION_INDIVIDUAL_CHARGES";
export const CHARGE_DEFINITION_REPORT_PARAMETERS_TYPE =
  "CYCLIC_CHARGE_DEFINITION_REPORT_PARAMETERS";
export const REPORTS_PATH = "/v1/private/reports";

/** Backend returns 202 while the report is still being generated. */
export const PENDING_REPORT_STATUS = 202;

export const REPORT_FORMATS = {
  csv: {
    extension: "csv",
    mimeType: "text/csv",
    fallbackFileName: "raport_zasilen_cyklicznych.csv",
  },
  xlsx: {
    extension: "xlsx",
    mimeType:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    fallbackFileName: "raport_zasilen_cyklicznych.xlsx",
  },
} as const;

export type ReportFormat = keyof typeof REPORT_FORMATS;

export type ResponseHeaders = RawAxiosResponseHeaders | AxiosResponseHeaders;

/**
 * The report scope is a discriminated union: exactly one of `companyId` or
 * `chargeDefinitionId` is present, each mapping to its own report policy.
 */
export type ReportScope =
  | { companyId: string; chargeDefinitionId?: never }
  | { chargeDefinitionId: string; companyId?: never };

export interface FileReportResponse {
  status: number;
  blob: Blob;
  headers: ResponseHeaders;
}

/**
 * Body of a successful (202) create-report response. The contract guarantees
 * `fileReportId` on any 2xx; a 4xx/5xx surfaces through axios instead, so the
 * field is not optional here.
 */
export interface CreateFileReportResponse {
  fileReportId: string;
}
